import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'variables-editor-row',
  template: `
    <div class="variables-editor-row" [ngClass]="item.type" cdkDrag>
      <div class="variables-editor-row-number">{{ index | xpIndex }}</div>
      <div class="variables-editor-cell variables-editor-move" [ngClass]="{ locked: disableSort }">
        <button type="button" class="btn btn-defaut btn-lg" [disabled]="disableSort" cdkDragHandle tabindex="-1">
          <svg
            *ngIf="!disableSort"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            width="7.5px"
            height="24px"
            viewBox="0 0 7.5 24"
          >
            <g>
              <rect
                x="-3.2"
                y="11"
                transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 15.75 8.25)"
                style="fill: #999999;"
                width="14"
                height="2"
              />
            </g>
            <polygon style="fill: #999;" points="0,19 3.8,24 7.5,19" />
            <polygon style="fill: #999;" points="7.5,5 3.8,0 0,5" />
          </svg>
          <svg *ngIf="disableSort" width="15px" height="16.5px" viewBox="0 0 15 16.5">
            <g id="icon-list-lock_1_">
              <path
                style="fill: none; stroke: #999999; stroke-width: 2; stroke-miterlimit: 10;"
                d="M3,5.5C3,3,5,1,7.5,1S12,3,12,5.5"
              />
              <path
                style="fill: #999999;"
                d="M13.9,5.5H1.1C0.5,5.5,0,6,0,6.6v8.9c0,0.6,0.5,1.1,1.1,1.1h12.9c0.6,0,1.1-0.5,1.1-1.1V6.6
                        C15,6,14.5,5.5,13.9,5.5z M8,11.4v2.1H7v-2.1c-0.6-0.2-1-0.8-1-1.4c0-0.8,0.7-1.5,1.5-1.5S9,9.2,9,10C9,10.7,8.6,11.2,8,11.4z"
              />
            </g>
          </svg>
        </button>
      </div>
      <div class="variables-editor-cell-input variables-editor-key variables-editor-cell-padding">
        <div class="cell-container">
          <input
            type="text"
            [attr.name]="item[key]"
            class="form-control input-lg"
            [(ngModel)]="item[key]"
            (input)="onChange()"
            [disabled]="disableKey"
            [ngClass]="{ invalid: item.keyInvalid && item.keyTouched }"
            (blur)="item.keyTouched = true"
          />
        </div>
      </div>
      <div class="variables-editor-cell-input">
        <div class="cell-container select-box">
          <input
            type="text"
            class="form-control input-lg"
            [(ngModel)]="item[value]"
            (input)="onChange()"
            [disabled]="disableValue"
            [readOnly]="readonlyValue"
            [ngClass]="{ invalid: item.valueInvalid && item.valueTouched }"
            (blur)="item.valueTouched = true"
          />
          <expression-editor-icon
            [id]="rowId"
            [readonlyValue]="readonlyValue"
            [value]="item[value]"
            [type]="type"
            [index]="index"
            (valueChange)="onValueChange($event)"
          ></expression-editor-icon>
        </div>
      </div>
      <div class="variables-editor-cell variables-editor-remove" *ngIf="!hideRemove">
        <button type="button" class="btn btn-link btn-lg variables-editor-remove-btn" (click)="remove()" tabindex="-1">
          <i class="fa fa-times"></i>
        </button>
      </div>
      <div class="variables-editor-cell variables-editor-undo" *ngIf="showUndo">
        <button
          type="button"
          class="btn btn-link btn-lg variables-editor-remove-btn"
          [disabled]="item[value] === item.default"
          (click)="setDefault(item)"
          [matTooltip]="
            (usePackageDefault ? 'variables-editor-row.package-default' : 'variables-editor-row.system-default')
              | translate
          "
          matTooltipPosition="above"
        >
          <i class="fa fa-undo"></i>
        </button>
      </div>
      <div class="variables-editor-cell variables-editor-hint">
        <i
          class="fa fa-exclamation-circle form-control-info"
          matTooltip="Useful if you would like to run the same package from multiple schedules (e.g. different time ranges, etc.)"
          matTooltipPosition="before"
          matTooltipClass="before"
        ></i>
      </div>
    </div>
  `,
})
export class VariablesEditorRowComponent implements OnInit {
  @Input() item: any;
  @Input() disableKey = false;
  @Input() disableValue = false;
  @Input() readonlyValue = false;
  @Input() hideRemove = false;
  @Input() showUndo = false;
  @Input() usePackageDefault = false;
  @Input() disableSort = false;
  @Input() index: number;
  @Input() key: string;
  @Input() value: string;
  @Input() type: string;
  @Output() itemChange = new EventEmitter();
  @Output() itemRemove = new EventEmitter();
  rowId: string;

  ngOnInit() {
    this.rowId = uuidv4();
  }

  onChange() {
    this.itemChange.emit(this.item);
  }

  remove() {
    this.itemRemove.emit();
  }

  onValueChange({ code, id }: { code: string; id: string }) {
    if (id === this.rowId) {
      this.item[this.value] = code;
      this.itemChange.emit(this.item);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  identify(index: number, item) {
    return item[this.key];
  }

  setDefault(item) {
    this.item[this.value] = item.default;
  }
}
